import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from '@angular/core';

import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import {
  getFormattedDate,
  haveSameIds,
  isLargeScreen,
} from '../../../../../../global.variable';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { HolAndMessageService } from '../../hol-and-message.service';
@Component({
  selector: 'gtapp-add-edit-pinned-message',
  standalone: false,
  templateUrl: './add-edit-pinned-message.component.html',
  styleUrl: './add-edit-pinned-message.component.scss',
})
export class AddEditPinnedMessageComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;

  selectedMessage = signal<any>({});

  @Input() set selectedMessageInput(value: any) {
    this.selectedMessage.set(value);
    this.resetData();

    const messageId = this.selectedMessage()?.id
      ? btoa(this.selectedMessage()?.id)
      : '';

    if (messageId) {
      this.getMessageDetails(messageId);
    }
  }

  @Output() messageUpdated = new EventEmitter();

  messageToBePinned: any = '';
  pinTill: any;

  today = getFormattedDate();
  selectedUserListData: any = [];

  haveSameUserIdList: boolean = false;
  hasPinTillChanged: boolean = true;

  usersToBeExcluded: any;

  constructor(
    private toasterService: ToasterService,
    private _location: Location,
    private spinnerService: LoadingSpinnerService,
    private pinnedMessageService: HolAndMessageService,
    private route: ActivatedRoute,
    private dialogService: ModalDialogueService,
  ) {}
  async ngOnInit() {
    const messageId = this.route.snapshot.queryParamMap.get('pMId');

    if (messageId) {
      this.getMessageDetails(messageId);
      this.resetData();
    }
  }
  ngOnDestroy() {}

  async resetData() {
    this.selectedUserListData = [];
    this.messageToBePinned = '';
    this.pinTill = null;
    this.haveSameUserIdList = false;
  }

  getMessageDetails(messageId: string) {
    this.spinnerService.show('Fetching details from server');
    this.pinnedMessageService
      .getPinnedMessageDetail(messageId)
      .subscribe((response: any) => {
        if (response?.status != 'success') {
          this.toasterService.setMessage({
            errorMessage: response?.message,
            successMessage: '',
          });
          return;
        }
        this.selectedMessage.set(response?.data);
        this.formatSelectedMessageInfo();
      });
  }

  formatSelectedMessageInfo() {
    this.spinnerService.hide();
    this.messageToBePinned = this.selectedMessage()?.message;
    this.pinTill = this.selectedMessage()?.pin_till
      ? getFormattedDate(new Date(this.selectedMessage()?.pin_till))
      : null;
    this.onPinTillChange();
    this.selectedUserListData = this.selectedMessage()?.recipients?.map(
      (item: any) => ({
        selected: true,
        ...item,
      }),
    );
    this.haveSameUserIdList = haveSameIds(
      this.selectedMessage()?.recipients,
      'id',
      this.selectedUserListData,
      'id',
    );
  }

  focusElement(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, 100);
  }

  onSelectUser(event: any) {
    event.selected = !event?.selected;
    if (event?.selected) {
      const selectedUserIndex = this.selectedUserListData?.findIndex(
        (user: any) => event?.id == user?.id,
      );
      if (selectedUserIndex > -1) {
        this.selectedUserListData[selectedUserIndex] = event;
      } else {
        this.selectedUserListData.push(event);
      }
      this.selectedUserListData = [...this.selectedUserListData];
    } else {
      this.selectedUserListData = this.selectedUserListData?.filter(
        (user: any) => user?.id != event?.id,
      );
    }

    this.haveSameUserIdList = haveSameIds(
      this.selectedMessage()?.recipients,
      'id',
      this.selectedUserListData,
      'id',
    );
  }

  onCancelClick() {
    if (this.largeView) {
      this.messageUpdated.emit({ action: 'cancel' });
    } else {
      this._location.back();
    }
  }
  onDelete() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show('Removing Message');
        this.pinnedMessageService
          .updatePinnedMessage(
            btoa(this.selectedMessage()?.id),
            {},
            { delete_message: 1 },
          )
          .then((response: any) => {
            if (response?.status != 'success') {
              this.toasterService.setMessage({
                errorMessage: response?.message,
                successMessage: '',
              });
              return;
            }
            if (this.largeView) {
              this.messageUpdated.emit({ action: 'delete' });
            } else {
              this._location.back();
            }
          });
      }
    });
  }
  onSaveUpdate() {
    if (this.selectedMessage()?.id) {
      this.spinnerService.show('Updating Message');
      this.pinnedMessageService
        .updatePinnedMessage(
          btoa(this.selectedMessage()?.id),
          {
            message: this.messageToBePinned,
            pin_till: this.pinTill,
            user_ids: [
              ...new Set(
                this.selectedUserListData?.map((user: any) => user?.id),
              ),
            ],
          },
          {
            update_message:
              this.messageToBePinned == this.selectedMessage()?.message ? 0 : 1,

            update_pin_till:
              this.pinTill == this.selectedMessage()?.pin_till ? 0 : 1,

            update_user_ids: this.haveSameUserIdList ? 0 : 1,
          },
        )
        .then((response: any) => {
          if (response?.status != 'success') {
            this.toasterService.setMessage({
              errorMessage: response?.message,
              successMessage: '',
            });
            return;
          }
          if (this.largeView) {
            this.messageUpdated.emit({ action: 'updated' });
          }
          this.selectedMessage.set(response?.data);
          this.formatSelectedMessageInfo();
        });
    } else {
      this.spinnerService.show('Adding Message');
      this.pinnedMessageService
        .createPinnedMessage({
          message: this.messageToBePinned,
          pin_till: this.pinTill,
          user_ids: [
            ...new Set(this.selectedUserListData?.map((user: any) => user?.id)),
          ],
        })
        .then((response: any) => {
          if (response?.status != 'success') {
            this.toasterService.setMessage({
              errorMessage: response?.message,
              successMessage: '',
            });
            return;
          }
          if (this.largeView) {
            this.messageUpdated.emit({ action: 'saved' });
          } else {
            this._location.back();
          }
        });
    }
  }
  updatePinTill() {
    if (this.pinTill) {
      this.pinTill = null;
    } else {
      const tomorrow = new Date().getTime() + 24 * 60 * 60 * 1000;

      this.pinTill = getFormattedDate(tomorrow);
    }
    this.onPinTillChange();
  }
  onPinTillChange() {
    this.hasPinTillChanged =
      this.pinTill !=
      (this.selectedMessage()?.pin_till
        ? getFormattedDate(this.selectedMessage()?.pin_till)
        : null);
  }
}
